import { render } from "./override-warning.vue?vue&type=template&id=19e3c083&lang=pug"
import script from "./override-warning.vue?vue&type=script&lang=js"
export * from "./override-warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__